// import store from '@/store'
/* Layout */
import Layout from "@/layout";
/**
 * @param {Array} value
 * @returns {Boolean}
 * @example see @/views/permission/directive.vue
 */
const components = {};

//创建模块
components.materialDataSheet = () =>
  import("@/views/create/materialDataSheet.vue");
components.ComponentUnit = () => import("@/views/create/componentUnit.vue");

//查找模块
components.seekMaterialDataSheet = () =>
  import("@/views/seek/seekMaterialDataSheet.vue");
components.seekHasBeenSent = () => import("@/views/seek/seekHasBeenSent.vue");
components.seekReceived = () => import("@/views/seek/seekReceived.vue");

//三级路由时二级菜单需要配置的code
components.twoLevelCode = () => import("@/layout/towLevelView.vue");

// 支持服务
components.SupportServices = () => import("@/views/supportServices/index.vue");
// 报表设计
components.dataResource = () => import("@/views/dataResource/index.vue");
components.dataSet = () => import("@/views/dataSet/index.vue");
components.reportManage = () => import("@/views/reportManage/index.vue");

//辅助校验工具
components.toolReceiveMdsPage = () =>
  import("@/views/analyse/toolReceiveMdsSearch/toolReceiveMdsSearch.vue");
components.toolSeekMaterialDataSheet = () =>
  import(
    "@/views/analyse/toolSeekMaterialDataSheet/toolSeekMaterialDataSheet.vue"
  );

components.AnalyseSvhc = () => import("@/views/analyse/analyseSvhc.vue");
components.AuxiliaryVerificationTool = () =>
  import("@/views/analyse/auxiliaryVerificationTools.vue");
components.SpecialSubstanceAnalysis = () =>
  import("@/views/analyse/specialSubstanceAnalysis.vue");
components.ClassificationAnalysis = () => import("@/views/analyse/analyse");
components.specialSubstanceAnalysis = () =>
  import("@/views/analyse/specialSubstanceAnalysis.vue");
components.MdsAnalysis = () => import("@/views/analyse/mdsAnalysis.vue");

//数据转换
components.BatchForward = () =>
  import("@/views/dataTransform/BatchForward.vue");
components.CQCDataDownLoad = () =>
  import("@/views/dataTransform/CQCDataDownLoad.vue");
components.CQCDataSearch = () =>
  import("@/views/dataTransform/CQCDataSearch.vue");
components.UploadIMDSTrans = () =>
  import("@/views/dataTransform/UploadIMDSTrans.vue");
components.DownloadIMDSTrans = () =>
  import("@/views/dataTransform/DownloadIMDSTrans.vue");
components.AnalysisScipSubstance = () =>
  import("@/views/dataTransform/AnalysisScipSubstance.vue");

//分类管理
components.MDSClassManage = () =>
  import("@/views/classifyManagement/MDSClassManage.vue");

/* 管理 */
components.DepartmentManage = () =>
  import("@/views/platformAdmin/departmentManage.vue");
components.Entorguser = () => import("@/views/platformAdmin/entorguser.vue");
components.SysLog = () => import("@/views/platformAdmin/sysLog.vue");
components.UserLog = () => import("@/views/platformAdmin/userLog.vue");
components.UpDownRoleSet = () =>
  import("@/views/platformAdmin/upDownRoleSet.vue");
components.MergeEnt = () => import("@/views/platformAdmin/mergeEnt.vue");
components.VocSubstance = () =>
  import("@/views/platformAdmin/vocSubstance.vue");
components.VocDynConfig = () =>
  import("@/views/platformAdmin/vocDynConfig.vue");
components.Trustuser = () => import("@/views/platformAdmin/trustUser.vue");
components.SupplierSearch = () =>
  import("@/views/platformAdmin/supplierSearch.vue");
components.RegisterSupplier = () =>
  import("@/views/platformAdmin/enterpriseRegister.vue");
components.ModifyEnterpriseInformation = () =>
  import("@/views/platformAdmin/modifyEnterpriseInformation.vue");
components.BasicSubstanceManagement = () =>
  import("@/views/platformAdmin/basicSubstanceManagement.vue");
components.MdsStatistics = () =>
  import("@/views/platformAdmin/mdsStatistics.vue");
components.ChargeableNodesStatistics = () =>
  import("@/views/platformAdmin/chargeableNodesStatistics.vue");
components.UserDefinedRules = () =>
  import("@/views/analyse/customCheckActionTool");

/* 其它 */
components.TraceMds = () => import("@/views/other/traceMds.vue");
components.Message = () => import("@/views/other/message.vue");
components.MdsUploadStatistics = () =>
  import("@/views/other/mdsUploadStatistics.vue");
components.OrginfoUpdate = () => import("@/views/other/orginfoUpdate.vue");
components.CerManager = () => import("@/views/other/cerManager.vue");
components.MdsUpload = () => import("@/views/other/mdsUpload.vue");
components.MdsUpdate = () => import("@/views/other/mdsUpdate.vue");

/* 平台管理 */
components.BasicalOverviewSet = () =>
  import("@/views/platformAdmin/basicalOverviewSet.vue");
components.DataAdmin = () => import("@/views/platformAdmin/dataAdmin.vue");
components.ResourcesAdmin = () =>
  import("@/views/platformAdmin/resourcesAdmin.vue");
components.DigitalDitionary = () =>
  import("@/views/platformAdmin/digitalDitionary.vue");
components.EquipmentAdmin = () =>
  import("@/views/platformAdmin/equipmentAdmin.vue");
components.FleetAdmin = () => import("@/views/platformAdmin/fleetAdmin.vue");
components.LogAdmin = () => import("@/views/platformAdmin/logAdmin.vue");
components.ModelAdmin = () => import("@/views/platformAdmin/modelAdmin.vue");
components.RoleAdmin = () => import("@/views/platformAdmin/roleAdmin.vue");
components.SystemSet = () => import("@/views/platformAdmin/systemSet.vue");
components.UserAdmin = () => import("@/views/platformAdmin/userAdmin.vue");
components.VehicleAdmin = () =>
  import("@/views/platformAdmin/vehicleAdmin.vue");
components.TaskAdmin = () => import("@/views/platformAdmin/taskAdmin.vue");
components.BusinessAdmin = () =>
  import("@/views/platformAdmin/businessAdmin.vue");
components.RegionSet = () => import("@/views/platformAdmin/regionSet.vue");
components.DeptAdmin = () => import("@/views/platformAdmin/deptAdmin.vue");
components.digitalDitionary = () => import("@/views/platformAdmin/digitalDitionary.vue");
// 公告管理
components.AnnAdmin = () => import("@/views/platformAdmin/annAdmin.vue");
//请求
components.CreateRequest = () => import("@/views/request/createRequest.vue");
components.SearchRequest = () => import("@/views/request/searchRequest.vue");

//供应商协同管理
components.enterpriseContactPerson = () =>
  import("@/views/supplierCollaborationManagement/enterpriseContactPerson.vue");
components.SupplierRatingManagement = () =>
  import(
    "@/views/supplierCollaborationManagement/supplierRatingManagement.vue"
  );
components.DisclosureAndPush = () =>
  import("@/views/supplierCollaborationManagement/inforDisclosureAndPush.vue");
components.mdsComparison= () =>
  import("@/views/supplierCollaborationManagement/mdsComparison.vue");

//帮助模块
components.usermanual = () => import("@/views/help/usermanual.vue");
components.contactus = () => import("@/views/help/contactus.vue");
components.feedbackManagementList = () => import("@/views/help/feedbackManagementList.vue");
components.faq = () => import("@/views/help/faq.vue");
components.sq = () => import("@/views/help/sq.vue");

//再生料管理
components.dataManagement = () => import("@/views/recycledMaterial/dataManagement.vue");

export function filterAsyncRouter(asyncRouterMap) {
  // 遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = asyncRouterMap.filter((route) => {
    if (route.component && typeof route.component === "string") {
      // let url = '@/views/' + route.component.toLowerCase()+'/index.vue';
      route.component = components[route.component];
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children);
      }
      return true;
    } else if (!route.component) {
      route.component = components[route.name];
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children);
      }
      return true;
    } else {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children);
      }
      return true;
    }
  });

  return accessedRouters;
}
export function addLayout(menus) {
  // 遍历后台传来的路由字符串，转换为组件对象
  const layoutMenu = menus.map((menu) => {
    let obj;
    if (!menu.children) {
      obj = Object.assign({}, menu, {
        children: [
          {
            path: "",
            component: components[menu.name],
            name: menu.name,
            meta: menu.meta,
          },
        ],
      });
      delete obj.meta;
    } else {
      obj = menu;
    }
    obj.redirect = "noRedirect";
    obj.component = Layout;
    return obj;
  });

  return layoutMenu;
}
